import React, { Component, Fragment } from 'react'
import { Modal, ControlLabel, FormControl, Button, Row, Col } from 'react-bootstrap'
import { ErrorMessage, Formik, Form, Field } from 'formik'

export class LeagueEnrollmentForm extends Component {
  constructor(props) {
    super(props);
  }

  // render() {
  //   const {enrolInLeagues, EF1, disabled, formProps, planSet, plans} = this.props;

  //   var promotion_code_field = [];
  //   if (Object.keys(selected_plan).length !== 0) {
  //     if(waitlistTransaction){
  //       promotion_code_field.push(
  //         <Col sm={6} key={makeUniqueKey()} style={{paddingTop: "1%"}} className="form-group">
  //           <ControlLabel>Enter promo code</ControlLabel>
  //           <Field name="promo_code" id="promotion_code" className="opaque-grey form-control" disabled={disabled} onClick={() => this.resetPricingBreakdown()}/>
  //         </Col>
  //       )
  //     } else {
  //       promotion_code_field.push(
  //         <Col key={makeUniqueKey()} sm={6} style={{paddingTop: "1%"}} className="form-group">
  //           <ControlLabel>Enter promo code</ControlLabel>
  //           <Field name="promo_code" id="promotion_code" className="opaque-grey form-control" disabled={disabled} onClick={() => this.resetPricingBreakdown()}/>
  //         </Col>
  //       )
  //     }
  //   }

  //   return (
  //     <div className="dashboard-box selected-enrolment">
  //       <div style={{ overflow: "auto", padding: "2%" }}>
  //         {!EF1 && (
  //           <div className="white-text margin-2">
  //             <Row>
  //               <Col sm={6}>
  //                 <ControlLabel className="mobile-title control-lbl">
  //                   <img src="2.png" alt="no. step" className="num-icon" />{" "}
  //                   &nbsp;
  //                   {enrolInLeagues
  //                     ? "Select your pricing"
  //                     : "Select the Hoopstir Pricing Plan"}
  //                 </ControlLabel>
  //                 <Field
  //                   name="selected_plan"
  //                   id="selected_plan"
  //                   className="opaque-grey form-control"
  //                   component="select"
  //                   disabled={disabled}
  //                   onChange={(e) =>
  //                     this.planSelectHandler(
  //                       e.target.value,
  //                       formProps.setFieldValue
  //                     )
  //                   }
  //                 >
  //                   <option
  //                     value=""
  //                     key="plan-select"
  //                     //selected={!(plans.length === 1) && selected_plan[selectedLeague._id] === null}
  //                     selected={planSet}
  //                     disabled
  //                   >
  //                     Please Select
  //                   </option>
  //                   {plans}
  //                 </Field>
  //                 <ErrorMessage
  //                   component="div"
  //                   name="selected_plan"
  //                   className="invalid-feedback"
  //                 />
  //               </Col>
  //               {promotion_code_field}
  //             </Row>
  //             <br />
  //             {instalments.length !== 0 &&
  //               instalment_field(
  //                 instalments,
  //                 instalment_number,
  //                 selectedLeague,
  //                 selected_plan[selectedLeague._id]._id,
  //                 disabled,
  //                 this.onInstalmentClick
  //               )}
  //           </div>
  //         )}
  //         {!token || EF1 ? ( // - FOR CLUBS THAT ARE NOT EXISTING HOOPSTIR CUSTOMERS
  //           <div>
  //             <div className="margin-2">
  //               <AccountHolderDetails
  //                 handleAHDetails={this.handleAHDetails}
  //                 DOB={this.state.DOB}
  //                 values={props.values}
  //                 email={this.state.admin_email}
  //                 setFieldValue={props.setFieldValue}
  //                 handleDate={this.handleDate}
  //                 disabled={disabled}
  //                 EF1={EF1}
  //               />
  //             </div>
  //             <div className="margin-2">
  //               <OrgDetails
  //                 enrolInLeagues={enrolInLeagues}
  //                 handleOrgDetails={this.handleOrgDetails}
  //                 setFieldValue={props.setFieldValue}
  //                 disabled={disabled}
  //                 uploadFile={this.uploadFile}
  //                 EF1={EF1}
  //               />
  //             </div>
  //           </div>
  //         ) : (
  //           ""
  //         )}
  //         {enrolInLeagues ? (
  //           <div className="white-text margin-2" disabled={disabled}>
  //             <Row>
  //               <Col sm={6}>
  //                 <ControlLabel className="mobile-title control-lbl">
  //                   <img
  //                     src={token ? "3.png" : "5.png"}
  //                     alt="no. step"
  //                     className="num-icon"
  //                   />
  //                   &nbsp; Enrol Your Teams
  //                   <a
  //                     className="hint-tip"
  //                     onClick={() =>
  //                       this.setState({ enrolHint: !this.state.enrolHint })
  //                     }
  //                   >
  //                     <FontAwesomeIcon icon={faInfoCircle} color="white" />
  //                     {this.state.enrolHint ? (
  //                       <div className="hint-tip-text" id="name-hint">
  //                         <span>
  //                           Add team(s) you would like to enrol in the{" "}
  //                           {selectedLeague.ages} {selectedLeague.division}{" "}
  //                           {selectedLeague.group_name}.
  //                         </span>
  //                       </div>
  //                     ) : (
  //                       ""
  //                     )}
  //                   </a>
  //                 </ControlLabel>
  //               </Col>
  //             </Row>
  //             <Row>{this.renderTeams(props.setFieldValue)}</Row>
  //             <ErrorMessage
  //               component="div"
  //               name="teams"
  //               className="invalid-feedback"
  //             />
  //           </div>
  //         ) : (
  //           <div className="margin-2">
  //             <PaymentDetails disabled={disabled} />
  //           </div>
  //         )}
  //         {EF1 ? (
  //           ""
  //         ) : (
  //           <div className="margin-2">
  //             <Field name="checkBox" type="checkbox" disabled={disabled} />
  //             <a
  //               className="white-text orange-hover"
  //               style={{ paddingLeft: "0.5em" }}
  //               onClick={this.handleWaiverModal}
  //             >
  //               I have read and agree with the{" "}
  //               <span style={{ textDecoration: "underline" }}>terms</span> that
  //               pertain to{" "}
  //               {selectedLeague ? selectedLeague.group_name : "Hoopstir"}
  //             </a>
  //             {props.values.checkBox === false ? (
  //               <div className="invalid-feedback">
  //                 Please read and accept the terms to continue
  //               </div>
  //             ) : (
  //               <ErrorMessage
  //                 component="div"
  //                 name="checkBox"
  //                 className="invalid-feedback"
  //               />
  //             )}
  //           </div>
  //         )}

  //         <div className="margin-2" style={{ display: "flex" }}>
  //           {props.isValid === false &&
  //             checkFormik === true &&
  //             this.checkEmptyFields()}
  //           {this.state.EF1Submitted ? <Col sm={3}></Col> : submission}
  //           {this.state.displayPaymentForm && this.state.showPricingBreakdown
  //             ? payment_field
  //             : ""}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
}
